import { render, staticRenderFns } from "./huecos.vue?vue&type=template&id=040187d0"
import script from "./huecos.vue?vue&type=script&lang=js"
export * from "./huecos.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports